import React, { useState } from 'react';

const portfolioProjects = [
  {
    id: 1,
    title: 'Parle Products',
    category: 'Food & Beverage',
    image: 'https://www.stercodigitex.com/uploads/portfolio/webp/1623771022_731eb0c55effdcd5b05e.webp',
    description: 'Complete digital transformation for India\'s leading biscuit manufacturer',
    services: ['Web Development', 'E-commerce', 'Digital Marketing'],
    featured: true,
    link: '#'
  },
  {
    id: 2,
    title: 'Jubilant FoodWorks',
    category: 'Restaurant Chain',
    image: 'https://www.stercodigitex.com/uploads/portfolio/webp/1623771381_66bf4cd31014aec86f18.webp',
    description: 'Multi-brand restaurant chain digital platform development',
    services: ['Web Development', 'Mobile App', 'SEO'],
    featured: true,
    link: '#'
  },
  {
    id: 3,
    title: 'Amity University',
    category: 'Education',
    image: 'https://www.stercodigitex.com/uploads/portfolio/webp/1623771112_c57bef6052b42e601aea.webp',
    description: 'Comprehensive educational platform with student management system',
    services: ['Web Development', 'CMS', 'Interactive Media'],
    featured: false,
    link: '#'
  },
  {
    id: 4,
    title: 'Little Tags Luxury',
    category: 'Fashion & Lifestyle',
    image: 'https://www.stercodigitex.com/uploads/portfolio/webp/1623776214_2332077ee01cf78654c4.webp',
    description: 'Premium fashion brand e-commerce platform with luxury experience',
    services: ['E-commerce', 'UI/UX Design', 'Digital Marketing'],
    featured: false,
    link: '#'
  },
  {
    id: 5,
    title: 'AIS Glass',
    category: 'Manufacturing',
    image: 'https://www.stercodigitex.com/uploads/portfolio/webp/1654080868_636ee792caefadaa13b1.webp',
    description: 'Industrial glass manufacturer digital presence and lead generation',
    services: ['Web Development', 'SEO', 'Lead Generation'],
    featured: false,
    link: '#'
  },
  {
    id: 6,
    title: 'CP Plus',
    category: 'Security & Technology',
    image: 'https://www.stercodigitex.com/uploads/portfolio/webp/1626343816_85fdd85a87bb5cfc68b5.webp',
    description: 'Security solutions provider with advanced product showcase',
    services: ['Web Development', 'Product Catalog', 'Digital Marketing'],
    featured: true,
    link: '#'
  }
];

const categories = ['All', 'Food & Beverage', 'Restaurant Chain', 'Education', 'Fashion & Lifestyle', 'Manufacturing', 'Security & Technology'];

export default function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [visibleProjects, setVisibleProjects] = useState(6);

  const filteredProjects = selectedCategory === 'All' 
    ? portfolioProjects 
    : portfolioProjects.filter(project => project.category === selectedCategory);

  const displayedProjects = filteredProjects.slice(0, visibleProjects);
  const hasMore = visibleProjects < filteredProjects.length;

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Portfolio Clients
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Discover the success stories of businesses we've helped transform through innovative digital solutions
          </p>
          
          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">150+</div>
              <div className="text-gray-600 font-medium">Projects Completed</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">98%</div>
              <div className="text-gray-600 font-medium">Client Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">25+</div>
              <div className="text-gray-600 font-medium">Industries Served</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">5+</div>
              <div className="text-gray-600 font-medium">Years Experience</div>
            </div>
          </div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => {
                setSelectedCategory(category);
                setVisibleProjects(6);
              }}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 shadow-sm'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {displayedProjects.map((project) => (
            <div
              key={project.id}
              className={`group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 ${
                project.featured ? 'ring-2 ring-blue-500' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {project.featured && (
                  <div className="absolute top-4 left-4">
                    <span className="bg-yellow-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      Featured
                    </span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <a
                    href={project.link}
                    className="bg-white text-gray-900 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-gray-100 transition-colors"
                  >
                    View Project →
                  </a>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
                    {project.category}
                  </span>
                  {project.featured && (
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                  )}
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {project.title}
                </h3>
                
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                  {project.description}
                </p>
                
                <div className="flex flex-wrap gap-2">
                  {project.services.map((service, index) => (
                    <span
                      key={index}
                      className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium"
                    >
                      {service}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {hasMore && (
          <div className="text-center">
            <button
              onClick={() => setVisibleProjects(prev => prev + 3)}
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 hover:shadow-lg transition-all duration-300"
            >
              Load More Projects
            </button>
          </div>
        )}

        {/* CTA Section */}
        <div className="mt-20 text-center rounded-2xl p-12 text-white" style={{ backgroundColor: 'rgb(17, 53, 77)' }}>
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Join Our Success Stories?
          </h3>
          <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Let us help you achieve the same level of success as our portfolio clients. Get started with a free consultation today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Start Your Project
            </a>
            <a
              href="/projects"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors"
            >
              View All Projects
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
